// projectId / photoId / size / edited?
export type PreviewId = `${string}/${string}/${string}`

export const getPreviewId = (props: {
	projectId: string
	photoId: string
	size: PreviewSize
	edited?: boolean
	digest?: string
}): PreviewId => {
	const { projectId, photoId, size, edited, digest } = props
	if (edited || digest) {
		return `${projectId}/${photoId}/${size}/edited`
	} else {
		return `${projectId}/${photoId}/${size}`
	}
}

// The number is the size of the minimum dimension of an embedded thumbnail that
// needs to be extracted.
export enum PreviewSize {
	small = 100, //Minimum: 100, Ideal: 512
	medium = 1200, //Minimum: 1200, Ideal: 1620
	large = 2000,
	fullSize = 6000, //We shouldnt need to request this from RawMetadataLoader, this is generated with half demosaic result
}

export type PreviewTag = "extracted" | "rendered" | "edited" | "original"

export interface Preview {
	url: string
	storageSize: number
	size: PreviewSize
	tags: PreviewTag[]
	digest?: string
}

export type PreviewInfo = {
	projectId: string
	photoId: string
	data: Blob
	size: PreviewSize
	tags: PreviewTag[]
	digest?: string
}
